import React from "react";
import { User, ChevronDown, Settings, Crown, Shield, LogOut } from "lucide-react";
import { UsageWidget } from "./UsageWidget";

const MASTER_ADMIN_EMAIL = "hello@proximalbs.com";

export const UserMenu = ({ user, openDropdown, setOpenDropdown, toggleDropdown, handleNavigate, handleLogout }) => (
  <div
    className="relative dropdown-container"
    onMouseEnter={() => setOpenDropdown('user')}
    onMouseLeave={() => setOpenDropdown(null)}
  >
    <button
      onClick={() => toggleDropdown('user')}
      className="flex items-center space-x-2 p-1 rounded-xl hover:bg-white/5 transition-all"
      data-testid="user-avatar-dropdown"
    >
      {user.picture ? (
        <img src={user.picture} alt={user.name} className="w-8 h-8 rounded-full border-2 border-purple-500" data-testid="user-avatar" />
      ) : (
        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-purple-500/40 to-pink-500/40 border-2 border-purple-500 flex items-center justify-center" data-testid="user-avatar">
          <User className="w-4 h-4 text-purple-300" />
        </div>
      )}
      <span className="text-sm text-gray-300 hidden lg:inline" data-testid="user-name">{user.name?.split(" ")[0]}</span>
      <ChevronDown className={`w-3 h-3 text-gray-500 transition-transform duration-200 ${openDropdown === 'user' ? 'rotate-180' : ''}`} />
    </button>
    <div className={`absolute right-0 pt-2 w-80 bg-transparent z-50 ${openDropdown === 'user' ? '' : 'pointer-events-none'}`}>
      <div className={`py-2 bg-gray-900/95 backdrop-blur-xl border border-gray-700 rounded-xl shadow-2xl transition-all duration-200 origin-top-right ${openDropdown === 'user' ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
        <div className="px-4 py-3 border-b border-white/[0.06]">
          <p className="text-sm font-semibold text-white truncate">{user.name}</p>
          <p className="text-xs text-gray-500 truncate">{user.email}</p>
        </div>
        {openDropdown === 'user' && (
          <div className="border-b border-white/[0.06]">
            <UsageWidget canSeeOrg={user.email === MASTER_ADMIN_EMAIL || user.role === 'org_admin' || user.role === 'admin' || user.role === 'owner'} />
          </div>
        )}
        <button onClick={() => { handleNavigate("/profile"); setOpenDropdown(null); }} className="w-full px-4 py-2.5 text-sm text-left text-gray-300 hover:text-white hover:bg-white/10 transition-colors flex items-center gap-2.5" data-testid="nav-profile-link">
          <User className="w-4 h-4 text-purple-400" />Mi Cuenta
        </button>
        <button onClick={() => { handleNavigate("/brand-profile"); setOpenDropdown(null); }} className="w-full px-4 py-2.5 text-sm text-left text-gray-300 hover:text-white hover:bg-white/10 transition-colors flex items-center gap-2.5">
          <Settings className="w-4 h-4 text-cyan-400" />Configuracion de Marca
        </button>
        <button onClick={() => { handleNavigate("/pricing"); setOpenDropdown(null); }} className="w-full px-4 py-2.5 text-sm text-left text-gray-300 hover:text-white hover:bg-white/10 transition-colors flex items-center gap-2.5">
          <Crown className="w-4 h-4 text-amber-400" />Planes
        </button>
        {user.email === MASTER_ADMIN_EMAIL && (
          <button onClick={() => { handleNavigate("/admin"); setOpenDropdown(null); }} className="w-full px-4 py-2.5 text-sm text-left text-red-400 hover:text-red-300 hover:bg-red-500/10 transition-colors flex items-center gap-2.5" data-testid="nav-admin-link">
            <Shield className="w-4 h-4" />Admin Command Center
          </button>
        )}
        <div className="mx-3 my-1 h-px bg-white/[0.06]" />
        <button onClick={() => { handleLogout(); setOpenDropdown(null); }} className="w-full px-4 py-2.5 text-sm text-left text-red-400 hover:text-red-300 hover:bg-red-500/10 transition-colors flex items-center gap-2.5" data-testid="logout-button">
          <LogOut className="w-4 h-4" />Cerrar Sesion
        </button>
      </div>
    </div>
  </div>
);
